export default class BulkGenerateReportingPeriodsRequest {
    fiscalYear = 0;
    startDate = '';
    numberOfPeriods = 13;
    periodLengthDays = 28;
}
